@if (dryersType) {
  <div class="d-flex">
    <div class="side-nav-wrapper">
      <h5 class="title text-primary">{{ 'SELECT_DRYER' | translate }}</h5>
      <hr />
      <div class="list-of-dryers">
        <ul class="list-unstyled ps-0">
          <li class="mb-1">
            @for (grandparent of dryersType; track grandparent) {
              <div class="form-group">
                <label class="form-check-label dryer-group bg-info p-1 mb-1">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [(ngModel)]="grandparent.isChecked"
                    [indeterminate]="grandparent.isIndeterminate"
                    (change)="onCheckboxChange(grandparent)" />
                  <span class="p-1 fw-bold">{{ grandparent.translationKey | translate }}</span>
                </label>
                <ul class="list-unstyled ps-3">
                  @for (parent of grandparent.children; track parent) {
                    <li class="form-check">
                      <label class="form-check-label mb-2">
                        <input
                          type="checkbox"
                          class="form-check-input"
                          [(ngModel)]="parent.isChecked"
                          [indeterminate]="parent.isIndeterminate"
                          (change)="onCheckboxChange(parent)" />
                        <span class="fw-normal">{{ parent.translationKey | translate }}</span>
                      </label>
                      <ul class="list-unstyled ps-3">
                        @for (child of parent.children; track child) {
                          <li class="form-check">
                            <label class="form-check-label mb-2">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                [(ngModel)]="child.isChecked"
                                (change)="onCheckboxChange(child)" />
                              <span class="fw-normal">{{ child.translationKey | translate }}</span>
                            </label>
                          </li>
                        }
                      </ul>
                    </li>
                  }
                </ul>
              </div>
            }
          </li>
        </ul>
      </div>
    </div>
  </div>
}
